"use client";

import { useEffect, useState } from "react";

// Vrai une fois la page défilée au-delà de `offset` px. Sert à ne révéler la
// barre CTA collante mobile qu'après le CTA du hero : sur un petit écran
// (iPhone SE), les deux se superposent sinon et se lisent comme un doublon.
export function useScrolledPast(offset: number): boolean {
  const [past, setPast] = useState(false);

  useEffect(() => {
    const onScroll = () => setPast(window.scrollY > offset);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [offset]);

  return past;
}
